import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 10px;\n  margin: 0 0 0 -10px;\n  cursor: pointer;\n\n  svg {\n    display: block;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 600;\n  margin: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          opacity: ", ";\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          visibility: hidden;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-bottom: 1px solid rgba(240, 240, 240, ", ");\n    box-shadow: 0 3px 15px 0 rgba(0, 0, 0, ", ");\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: inherit;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  padding: 0 16px;\n  display: grid;\n  grid-template-columns: 40px 1fr 40px;\n  align-items: center;\n  justify-content: space-between;\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 66px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import { Heading2, Subheading } from '../Typography';
import styled, { css } from '../utils/styling/styled-components';
import { ACTION_STRIP_TITLE, ACTION_STRIP_SUBTEXT, BACK_BUTTON } from '../utils/testing/TestIDs';
import { useStickyScroll } from './hooks';
var Wrapper = styled.div(_templateObject());
var Container = styled.div(_templateObject2(), function (props) {
  return css(_templateObject3(), props.theme.colors.white, props.scrollPercent, props.scrollPercent * 0.05);
});
var TitleArea = styled.div(_templateObject4(), function (props) {
  switch (props.visibilityMode) {
    case 'none':
      return css(_templateObject5());

    case 'onscroll':
      return css(_templateObject6(), props.scrollPercent);

    default:
      return '';
  }
});
var Title = styled(Heading2).attrs({
  as: 'h1'
})(_templateObject7());
var Subtext = styled(Subheading).attrs({
  as: 'h3'
})(_templateObject8(), function (props) {
  return props.theme.colors.stone;
});
var BackButton = styled.button.attrs({
  dataTestid: BACK_BUTTON
})(_templateObject9());
var Action = styled.div(_templateObject10());
export var MobileStrip = function MobileStrip(_ref) {
  var title = _ref.title,
      subtext = _ref.subtext,
      action = _ref.action,
      onBack = _ref.onBack,
      _ref$backIcon = _ref.backIcon,
      backIcon = _ref$backIcon === void 0 ? AcornsIcon.Icon.UtilityArrowLeft : _ref$backIcon,
      _ref$titleVisibility = _ref.titleVisibility,
      titleVisibility = _ref$titleVisibility === void 0 ? 'always' : _ref$titleVisibility,
      className = _ref.className,
      _ref$titleTestId = _ref.titleTestId,
      titleTestId = _ref$titleTestId === void 0 ? ACTION_STRIP_TITLE : _ref$titleTestId,
      _ref$subtextTestId = _ref.subtextTestId,
      subtextTestId = _ref$subtextTestId === void 0 ? ACTION_STRIP_SUBTEXT : _ref$subtextTestId,
      _ref$showBackButton = _ref.showBackButton,
      showBackButton = _ref$showBackButton === void 0 ? true : _ref$showBackButton;

  var _useStickyScroll = useStickyScroll({
    scrollDistance: 60
  }),
      scrollPercent = _useStickyScroll.scrollPercent;

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, {
    scrollPercent: scrollPercent,
    className: className
  }, showBackButton && /*#__PURE__*/React.createElement(BackButton, {
    onClick: onBack
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: backIcon,
    width: "24px",
    height: "24px"
  })), /*#__PURE__*/React.createElement(TitleArea, {
    scrollPercent: scrollPercent,
    visibilityMode: titleVisibility
  }, title && /*#__PURE__*/React.createElement(Title, {
    "data-testid": titleTestId
  }, title), subtext && /*#__PURE__*/React.createElement(Subtext, {
    "data-testid": subtextTestId
  }, subtext)), /*#__PURE__*/React.createElement(Action, null, action)));
};